import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon, LoaderCircleIcon, RefreshCwIcon } from 'lucide-react';
import { Lightbox } from '../components/Lightbox';
import { getGalleryErrorMessage, loadRemoteGalleryImages } from '../data/gallery';
import { GalleryImage } from '../data/types';
export const Gallery = () => {
  const [images, setImages] = useState<GalleryImage[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const loadGallery = async () => {
    setIsLoading(true);
    setError('');
    try {
      setImages(await loadRemoteGalleryImages());
    } catch (loadError) {
      setImages([]);
      setError(getGalleryErrorMessage(loadError));
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    void loadGallery();
  }, []);
  const openLightbox = (index: number) => {
    setCurrentIndex(index);
    setLightboxOpen(true);
  };
  const handleNext = () => {
    setCurrentIndex(prev => (prev + 1) % images.length);
  };
  const handlePrev = () => {
    setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  };
  return <div className="min-h-screen w-full bg-background py-12" data-id="element-595" data-mp="2b6p5kt5zols2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-596" data-mp="2fawt4n0pnvop">
        <div className="text-center mb-16" data-id="element-597" data-mp="32z6e5mq3ofes">
          <motion.h1 initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-6xl font-display font-bold text-gray-900 mb-4" data-id="element-598" data-mp="330hfzgzzjd39">
            Galerija
          </motion.h1>
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.2
        }} className="text-xl text-gray-600" data-id="element-599" data-mp="1ijunu40k40ia">
            Zavirite u svijet zabave i pogledajte naše napuhance u akciji!
          </motion.p>
        </div>

        {isLoading && <div className="py-20 flex flex-col items-center gap-3 text-gray-600" role="status" data-id="element-600" data-mp="3fi215qicjwd6">
            <LoaderCircleIcon className="animate-spin text-primary" size={32} data-id="element-601" data-mp="3bfnj38mi50my" />
            <p className="font-medium" data-id="element-602" data-mp="36i5719d6u5aq">Učitavamo galeriju…</p>
          </div>}

        {!isLoading && error && <div className="max-w-2xl mx-auto rounded-2xl border border-red-200 bg-red-50 p-6 text-center" data-id="element-603" data-mp="31hr76elqq1ns">
            <AlertCircleIcon className="mx-auto text-red-600 mb-3" size={30} data-id="element-604" data-mp="2wk7litmpqmlt" />
            <h2 className="font-bold text-red-900" data-id="element-605" data-mp="2sim6b1mphw8g">
              Galerija trenutačno nije dostupna
            </h2>
            <p className="mt-2 text-sm text-red-800" data-id="element-606" data-mp="uqrtptew31p9">{error}</p>
            <button type="button" onClick={() => void loadGallery()} className="mt-5 inline-flex items-center gap-2 rounded-xl bg-gray-900 px-4 py-2.5 font-bold text-white transition-colors hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2" data-id="element-607" data-mp="qpy3uuhvzctq">
              <RefreshCwIcon size={17} data-id="element-608" data-mp="2iefn2eos1kjb" /> Pokušaj ponovno
            </button>
          </div>}

        {!isLoading && !error && images.length === 0 && <div className="text-center py-20 text-gray-500" data-id="element-609" data-mp="1pprudy1p7svq">
            Galerija je trenutno prazna.
          </div>}

        {!isLoading && !error && images.length > 0 && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.1
      }} className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-610" data-mp="1yq6j77dvfq3z">
            {images.map((img, index) => <motion.button key={img.id} type="button" whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="aspect-square rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow bg-white text-left focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2" onClick={() => openLightbox(index)} aria-label={`Otvori sliku: ${img.caption || 'Galerija'}`} data-id="element-611" data-mp="3f2lkohna7co3" data-mpi={index}>
                <img src={img.url} alt={img.caption || 'Fotografija iz JumpLand galerije'} className="w-full h-full object-cover" data-id="element-612" data-mp="3rlzegbztgq8n" />
              </motion.button>)}
          </motion.div>}
      </div>

      <Lightbox images={images} currentIndex={currentIndex} isOpen={lightboxOpen} onClose={() => setLightboxOpen(false)} onNext={handleNext} onPrev={handlePrev} data-id="element-613" data-mp="j80hb713yytk" />
    </div>;
};